import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions, listWorkOrders as listCalendarWorkOrders } from './WorkOrderCalendar.slice'

function listWorkOrders () {
  store.dispatch(listCalendarWorkOrders() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.nextMonth, listWorkOrders),
    takeLatest(actions.previousMonth, listWorkOrders)
  ])
}
